import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "pt-16 my-2 block text-3xl leading-8 font-extrabold tracking-tight text-gray-900 mb-1 sm:text-4xl" }, "Install the NsLookup browser extension", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "You can install a browser plugin to quickly access DNS records for a website you're on. On desktop, the following browsers are supported:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://addons.opera.com/en/extensions/details/nslookup-find-dns-records/"
  }, " Install the NsLookup.io Opera extension ")
], -1)

import MetaTags from '@/components/MetaTags.vue';
import ContentPage from '@/components/layout/ContentPage.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'InstallView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Install the NsLookup browser extension",
        description: "View DNS records in your browser or on a mobile device. Inspect all DNS record types and popular DNS caches as well as multiple geographical locations.",
        url: "https://www.nslookup.io/install/"
      })
    ])),
    _createVNode(ContentPage, null, {
      content: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/install/how-to-view-dns-records-in-firefox/" }, {
              default: _withCtx(() => [
                _createTextVNode("Install the NsLookup.io Firefox extension")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/install/how-to-view-dns-records-in-chrome/" }, {
              default: _withCtx(() => [
                _createTextVNode("Install the NsLookup.io Chrome extension")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/install/how-to-view-dns-records-in-edge/" }, {
              default: _withCtx(() => [
                _createTextVNode("Install the NsLookup.io Edge extension")
              ]),
              _: 1
            })
          ]),
          _hoisted_3
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})